export const ParsedStatus = {
	none: -1,
	empty: 0,
	done: 1,
}
